import React from 'react';
import moment from 'moment';
import Badge from '@mui/material/Badge'
import { Avatar } from 'stream-chat-react';
import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemText from '@mui/material/ListItemText'
import { AccessTime } from '@mui/icons-material';
import { Box } from '@mui/material';
export const TeamChannelPreview = ({name, unreadCount, image, lastMessageDate }) => (
  <ListItem divider dense>
    <ListItemAvatar>
      <Badge badgeContent={unreadCount} color="error" >
      <Avatar image={image} name={name} size={32} />
      </Badge>
    </ListItemAvatar>
    <ListItemText
      primaryTypographyProps={{ color: '#fff' }}
      secondaryTypographyProps={{ component: 'div', color: '#fff', fontWeight: 300, fontSize: 12 }}
      primary={name}
      secondary={<Box sx={{ display: 'flex', alignItems: 'center'}} >
        <AccessTime sx={{ fontSize: 12, mr: 0.5}} color="secondary" />
        <Box>{moment(lastMessageDate || new Date()).format('ll')}</Box>
        </Box> }
        />
  </ListItem>
);